import types from 'redux/types';
import { checkTypeValue } from 'helpers';
import Queue from 'helpers/queue';

const queueUpdatingOffer = new Queue();
const queueUpdatingDomain = new Queue();

const initialState = {
  listOffer: [],
  offer: {},

  isGettingListOffer: false,
  isGotList: false,
  isGettingOfferById: false,
  isUpdating: false,
  isCreating: false,
  isDeleting: false,
  isFiltering: false,
  isLast: false,

  errorGetListOffer: null,
  errorGetOffer: null,
  errorCreate: null,
  errorUpdate: null,
  errorDelete: null,
  errorQueueUpdatingOffer: null,
  errorUpdateDomain: null,

  queueUpdatingOffer: [],
  queueUpdatingDomain: [],
};

export default (state, actions) => {
  if (checkTypeValue(state, 'undefined')) {
    return initialState;
  }
  switch (actions.type) {
    case types.REQUEST_UPDATE_DOMAIN_CAMPAIGN:
      queueUpdatingDomain.pushToQueue(actions.id);
      return {
        ...state,
        queueUpdatingDomain: queueUpdatingDomain.queue,
      };

    case types.REQUEST_UPDATE_DOMAIN_CAMPAIGN_SUCCESS:
      queueUpdatingDomain.removeFromQueue(actions.id);
      return {
        ...state,
        queueUpdatingDomain: queueUpdatingDomain.queue,
      };

    case types.REQUEST_UPDATE_DOMAIN_CAMPAIGN_FAILED:
      queueUpdatingDomain.removeFromQueue(actions.id);
      return {
        ...state,
        errorUpdateDomain: actions.error,
        queueUpdatingDomain: queueUpdatingDomain.queue,
      };

    case types.REQUEST_UPDATE_OFFER_CAMPAIGN: {
      queueUpdatingOffer.pushToQueue(actions.id);
      return {
        ...state,
        queueUpdatingOffer: queueUpdatingOffer.queue,
      };
    }

    case types.REQUEST_UPDATE_OFFER_CAMPAIGN_SUCCESS: {
      queueUpdatingOffer.removeFromQueue(actions.id);
      return {
        ...state,
        queueUpdatingOffer: queueUpdatingOffer.queue,
        errorQueueUpdatingOffer: null,
      };
    }

    case types.REQUEST_UPDATE_OFFER_CAMPAIGN_FAILED: {
      queueUpdatingOffer.removeFromQueue(actions.id);
      return {
        ...state,
        errorQueueUpdatingOffer: actions.error,
        queueUpdatingOffer: queueUpdatingOffer.queue,
      };
    }

    case types.REQUEST_FILTER_OFFERS:
      return {
        ...state,
        isFiltering: true,
      };

    case types.REQUEST_FILTER_OFFERS_SUCCESS:
      return {
        ...state,
        isFiltering: false,
        listOffer: actions.listOffer,
        isLast: actions.isLast,
      };

    case types.REQUEST_FILTER_OFFERS_FAILED:
      return {
        ...state,
        error: actions.error,
        isFiltering: false,
      };

    case types.REQUEST_GET_LIST_OFFER:
      return {
        ...state,
        isGettingListOffer: true,
      };

    case types.REQUEST_GET_LIST_OFFER_SUCCESS:
      return {
        ...state,
        isGotList: true,
        isGettingListOffer: false,
        listOffer: actions.data,
        errorGetListOffer: null,
        isLast: actions.isLast,
      };

    case types.REQUEST_GET_LIST_OFFER_FAILED:
      return {
        ...state,
        errorGetListOffer: actions.error,
        isGettingListOffer: false,
      };

    case types.REQUEST_GET_OFFER_BY_ID:
      return {
        ...state,
        isGettingOfferById: true,
      };

    case types.REQUEST_GET_OFFER_BY_ID_SUCCESS:
      return {
        ...state,
        isGettingOfferById: false,
        offer: actions.data,
        listOffer: actions.listOffer,
        errorGetOffer: null,
      };

    case types.REQUEST_GET_OFFER_BY_ID_FAILED:
      return {
        ...state,
        errorGetOffer: actions.error,
        isGettingOfferById: false,
      };

    case types.REQUEST_CREATE_OFFER:
      return {
        ...state,
        isCreating: true,
      };

    case types.REQUEST_CREATE_OFFER_SUCCESS:
      return {
        ...state,
        isCreating: false,
        errorCreate: null,
      };

    case types.REQUEST_CREATE_OFFER_FAILED:
      return {
        ...state,
        errorCreate: actions.error,
        isCreating: false,
      };

    case types.REQUEST_UPDATE_OFFER:
      return {
        ...state,
        isUpdating: true,
      };

    case types.REQUEST_UPDATE_OFFER_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        listOffer: actions.listOffer,
        offer: actions.offer,
        errorUpdate: null,
      };

    case types.REQUEST_UPDATE_OFFER_FAILED:
      return {
        ...state,
        errorUpdate: actions.error,
        isUpdating: false,
      };

    case types.REQUEST_DELETE_OFFER:
      return {
        ...state,
        isDeleting: true,
      };

    case types.REQUEST_DELETE_OFFER_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        errorDelete: null,
      };

    case types.REQUEST_DELETE_OFFER_FAILED:
      return {
        ...state,
        errorDelete: actions.error,
        isDeleting: false,
      };

    default:
      return state;
  }
};
